import ReviewsIcon from 'assets/icons/reviews/stat-reviews.svg';
import RatingIcon from 'assets/icons/reviews/stat-rating.svg';
import FiveStarIcon from 'assets/icons/reviews/stat-five-star.svg';
import LearnersIcon from 'assets/icons/reviews/stat-learners.svg';
import CoursesIcon from 'assets/icons/reviews/stat-courses.svg';
import LinkedinIcon from 'assets/icons/reviews/stat-linkedin.svg';

import classes from './ReviewsStats.module.scss';

const formatNumber = (value) => (value ?? 0).toLocaleString('en-US');

const ReviewsStats = ({ summary }) => {
	const stats = [
		{
			icon: <ReviewsIcon className={classes['stat-icon']} />,
			value: formatNumber(summary.total_lecture_reviews),
			label: 'Total course review'
		},
		{
			icon: <RatingIcon className={classes['stat-icon']} />,
			value: `${summary.average_lecture_rating} / 5`,
			label: 'Average Course Rating'
		},
		{
			icon: <FiveStarIcon className={classes['stat-icon']} />,
			value: `${summary.five_star_percentage}%`,
			label: '5-Star Review percentage'
		},
		{
			icon: <LearnersIcon className={classes['stat-icon']} />,
			value: formatNumber(summary.total_users),
			label: 'Total Pharma Learners'
		},
		{
			icon: <CoursesIcon className={classes['stat-icon']} />,
			value: formatNumber(summary.reviewed_lectures_count),
			label: 'Courses Reviewed'
		},
		{
			icon: <LinkedinIcon className={classes['stat-icon']} />,
			value: formatNumber(summary.linkedin_shares_per_month),
			label: 'LinkedIn Shares this month'
		}
	];

	return (
		<div className={classes['stats']}>
			{stats.map((stat) => (
				<div key={stat.label} className={classes['stat']}>
					<div className={classes['stat-value']}>
						{stat.icon}
						<span>{stat.value}</span>
					</div>
					<span className={classes['stat-label']}>{stat.label}</span>
				</div>
			))}
		</div>
	);
};

export default ReviewsStats;
